import React, { useState } from "react"
import Icon from "../../../common/blocks/icon/Icon"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./Faq.module.scss"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

function Faq({ Qr, title }) {
  const [openIndexes, setOpenIndexes] = useState([])

  const toggleDetails = (index) => {
    const isOpen = openIndexes.includes(index)
    if (isOpen) {
      setOpenIndexes(openIndexes.filter((i) => i !== index))
    } else {
      setOpenIndexes([...openIndexes, index])
    }
  }
  return (
    <Section
      container={"large"}
      className={`${classNames.container} + pbl-8`}
    >
      <h2>{title}</h2>
      {Qr.map((item, i) => {
        const isOpen = openIndexes.includes(i)
        const icon = isOpen ? "open" : "close"
        return (
          <React.Fragment key={i}>
            <details
              open={isOpen}
              className={classNames.detailsContainer}
            >
              <summary
                className={classNames.summary}
                onClick={(e) => {
                  e.preventDefault()
                  toggleDetails(i)
                }}
              >
                <p>{item.attributes.question}</p>
                <Icon
                  icon={icon}
                  width="16"
                  height="16"
                  color="var(--gris)"
                />
              </summary>

              <ReactMarkdown
                children={item.attributes.response}
                remarkPlugins={[remarkGfm]}
              />
            </details>
          </React.Fragment>
        )
      })}
    </Section>
  )
}
export const name = "Faq"

export const init = (componentData) => {
  return (
    <Faq
      key={componentData.id}
      Qr={componentData.questions_reponses.data}
      title={componentData.label}
    />
  )
}

export default Faq
